//-------------------------------------------------------------------------------------------------------------------------------
//          _                   _       _           _                _                                 _                    _
//         / /\                / /\    / /\        /\ \             /\ \                              / /\                 /\ \
//        / /  \              / / /   / / /       /  \ \            \ \ \                            / /  \                \ \ \
//       / / /\ \            / /_/   / / /       / /\ \ \           /\ \_\                          / / /\ \               /\ \_\
//      / / /\ \ \          / /\ \__/ / /       / / /\ \_\         / /\/_/                         / / /\ \ \             / /\/_/
//     / / /  \ \ \        / /\ \___\/ /       / / /_/ / /        / / /                           / / /  \ \ \           / / /
//    / / /___/ /\ \      / / /\/___/ /       / / /__\/ /        / / /                           / / /___/ /\ \         / / /
//   / / /_____/ /\ \    / / /   / / /       / / /_____/        / / /                           / / /_____/ /\ \       / / /
//  / /_________/\ \ \  / / /   / / /       / / /\ \ \      ___/ / /__      ________________   / /_________/\ \ \  ___/ / /__
// / / /_       __\ \_\/ / /   / / /       / / /  \ \ \    /\__\/_/___\    /______________\ \ / / /_       __\ \_\/\__\/_/___\
// \_\___\     /____/_/\/_/    \/_/        \/_/    \_\/    \/_________/    \_______________\/ \_\___\     /____/_/\/_________/
//-------------------------------------------------------------------------------------------------------------------------------

export const LoadingUtil = {
    showLoading() {
        const loadingSpinner = document.getElementById("loadingSpinner");
        loadingSpinner?.classList.add("active");
    },

    hideLoading() {
        const loadingSpinner = document.getElementById("loadingSpinner");
        loadingSpinner?.classList.remove("active");
    }
};
